import { combineReducers } from 'redux';
import crl from './slices/crl.slice';

const reducer = combineReducers({
  crl
})

export default reducer;
